module.exports = __webpack_public_path__ + "img/coin.1fe3493c.png";